import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { injectIntl } from 'react-intl';
import { Checkbox } from 'antd';

import SlsOrdFulfillmentChartActions from '../../Stores/SlsOrdFulfillmentChart/Actions';

const CheckboxGroup = Checkbox.Group;

class SelectAveragesCheckBox extends React.PureComponent {
  constructor() {
    super();

    this.handleChange = this.handleChange.bind(this);
    // this.handleCheckAll = this.handleCheckAll.bind(this);
  }

  handleChange(list) {
    const { setVisibleKeys } = this.props;

    setVisibleKeys(list);
  }

  render() {
    const { visibleAverageKeys, intl } = this.props;
    const visibleAverageOptions = [
      { label: `${intl.formatMessage({ id: 'ord_created' })}`, value: 'ord_created' },
      { label: `${intl.formatMessage({ id: 'ord_picked' })}`, value: 'ord_picked' },
      { label: `${intl.formatMessage({ id: 'ord_loaded' })}`, value: 'ord_loaded' },
      { label: `${intl.formatMessage({ id: 'ord_delivered' })}`, value: 'ord_delivered' }
    ];

    return (
      <>
        <CheckboxGroup
          options={visibleAverageOptions}
          onChange={this.handleChange}
          value={visibleAverageKeys}
        />
      </>
    );
  }
}

SelectAveragesCheckBox.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,

  setVisibleKeys: PropTypes.func,
  visibleAverageKeys: PropTypes.arrayOf(PropTypes.string)
};

SelectAveragesCheckBox.defaultProps = {
  intl: {},

  setVisibleKeys() {},
  visibleAverageKeys: []
};

const mapStateToProps = state => ({
  visibleAverageKeys: state.slsOrdFulfillmentChart.slsOrdFulfillmentChartVisibleAverageKeys
});

const mapDispatchToProps = dispatch => ({
  setVisibleKeys: visibleKeys =>
    dispatch(SlsOrdFulfillmentChartActions.slsOrdFulfillmentChartSetVisibleAverageKeys(visibleKeys))
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(SelectAveragesCheckBox));
